<template>
  <page-layout>
    <div class="p-list">
      <div
        v-for="item in list"
        :key="item.id"
        class="p-list-item"
        @click="toDetail(item)"
      >
        <img :src="item.iconUrl" />
        <span>{{ item.zhName }}</span>
        <span>{{ item.enName }}</span>
      </div>
    </div>
  </page-layout>
</template>

<script>
export default {
  data() {
    return {
      list: []
    }
  },

  created() {
    this.list = window.__myProductList
  },

  methods: {
    toDetail(item) {
      console.info(item)
      location.href = `./detail.html?id=${item.id}`
    }
  }
}
</script>

<style lang="scss" scoped>
.p-list {
  height: calc(100% - 80px);
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  .p-list-item {
    cursor: pointer;
    display: inline-block;
    width: 360px;
    height: 440px;
    text-align: center;
    margin: 50px 56px;
    border-radius: 8px;
    // box-shadow: 0 4px 8px rgba($color: #000000, $alpha: 0.2);
  }
  .p-list-item:hover {
    background-color: #fff;
    box-shadow: 0 4px 8px rgba($color: #000000, $alpha: 0.2);
  }
  span:hover {
    color: #C83939;
  }
  img {
    margin-top: 10px;
    height: 300px;
    width: 200px;
    // margin: 0 auto;
    object-position: 50% 50%;
    object-fit: cover;
  }
  span{
    display: block;
    margin-top: 20px;
    text-align: center;
    font-size: 20px;
    color: #000;
    font-family: Inter-Bold, Inter;
    font-weight: bold;
    line-height: 22px;
  }
}

</style>
